import React from 'react'
import chewy from "../../images/chewy_one_line.png"

import "../../stylesheets/SpinnerSS.css"

function LoadingSpinner() {
    return (
        <div id='spinner_container'>
            <div id='spinner_pos'>
                <img id='chewyToken' className='spinner' src={ chewy } alt="loading"></img>
            </div>
        </div>
    )
}

export default LoadingSpinner